import React, { Component } from "react";
export default class BehaviorSection extends Component {
  componentDidMount() {
    console.log("props", this.props);
  }
  render() {
    var {
      name,
      behavior_q1_status,
      behavior_q1_description,
      behavior_q2_status,
      behavior_q2_description,
      behavior_q3_status,
      behavior_q3_description,
      behavior_q4_status,
      behavior_q4_description,
      behavior_q5_status,
      behavior_q5_description,
      behavior_q6_status,
      behavior_q6_description,
      behavior_q7_status,
      behavior_q7_description,
      behavior_q8_status,
      behavior_q8_description,
      behavior_q9_status,
      behavior_q9_description,
      behavior_q10_status,
      behavior_q10_description,
      total_behavior_marks,
      behaviour_symptom_status,
      apathy_symptom_status,
      loss_sympathy_symptom_status,
      perseverative_symptom_status,
      hyperorality_symptom_status,
    } = this.props.data;
    return (
      <div className="row border border-dark">
        <div className="col-lg-12">
          <p className="fs-19 py-3 ">
            Please ask the caregiver about the following possible behaviors.
            Symptoms should have occurred repeatedly and not just on one
            instance, and may have occurred prior to the development of any
            motor signs. Tick ‘Yes’, ‘No’ or ‘Don’t Know’. If ‘Yes’, please
            provide a brief description.
          </p>
          <hr />
          <ul
            style={{
              paddingLeft: 20,
              fontSize: 19,
            }}
          >
            <li style={{ listStyle: "square" }}>
              Guidance:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  Please complete this interview with the carer or relative in
                  private from the patient, ideally in a separate room. There
                  are five components to this screen.
                </li>
                <li style={{ listStyle: "circle" }}>
                  Some people may have noticed a change in all areas, some in a
                  few, and others may note there are no changes with the
                  patient. Please prompt the carer or relative to give any
                  examples if possible, which should be recorded on the form.
                </li>
                <li style={{ listStyle: "circle" }}>
                  The ECAS Behavior Screen is interview based and should
                  therefore be complete with the carer or relative.
                </li>
                <li style={{ listStyle: "circle" }}>
                  UNDER NO CIRCUMSTANCES SHOULD IT BE GIVEN TO THE CARER OR
                  RELATIVE TO COMPLETE ON THEIR OWN.
                </li>
              </ul>
            </li>
            <li style={{ listStyle: "square" }}>
              Administration:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  Please ask the carer about the listed possible behaviors.
                  Symptoms should have occurred repeatedly and not just on one
                  instance, and may have occurred prior to the development of
                  any motor signs. Tick ‘Yes’, ‘No’, or ‘Don’t Know’. If ‘Yes’,
                  please provide a brief description
                </li>
              </ul>
            </li>
            <li style={{ listStyle: "square" }}>
              Say:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  Please answer the following questions as honestly as you can.
                  If the symptom has occurred in more than one instance please
                  answer yes and give an example. Keep in mind that these
                  symptoms may have started prior to the development of any
                  motor signs.
                  <ul>
                    <li
                      style={{
                        listStyle: "circle",
                      }}
                    >
                      If any of the answers are yes, please ask to give an
                      example or explain
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li style={{ listStyle: "square" }}>
              Scoring:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  Give one mark for every ‘Yes’ response (range = 0-10)
                </li>
              </ul>
            </li>
          </ul>
          <hr />
        </div>
        <div className="col-lg-12 px-0">
          <table className="fs-19 table-black w-100 border border-dark text-right">
            <tbody>
              <tr>
                <td className="text-align-center">A</td>
                <td className="text-left" colSpan="4">
                  <b>Behavioral disinhibition</b>
                </td>
                <td style={{ width: 90 }} className="text-left">
                  Score
                </td>
              </tr>
              <tr>
                <td className="text-align-center">1</td>
                <td className="text-left" style={{ maxWidth: 250 }}>
                  Has {name ? name : "***"} ever exhibited socially
                  inappropriate behavior, inappropriate behavior with strangers
                  or criminal behavior?
                </td>

                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q1_status == "1" ? "button active" : "button"
                    }
                  >
                    Y
                  </button>
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q1_status == "N" ? "button active" : "button"
                    }
                  >
                    N
                  </button>
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q1_status == "DK" ? "button active" : "button"
                    }
                  >
                    DK
                  </button>
                </td>
                <td>
                  <input
                    type="number"
                    className="ecas-input-field"
                    placeholder="Score"
                    disabled={true}
                    value={behavior_q1_status == true ? 1 : 0}
                    style={{
                      width: "92%",
                      marginRight: 14,
                      marginBottom: 10,
                    }}
                  />
                </td>
              </tr>
              {behavior_q1_status == true && (
                <tr>
                  <td colSpan="2"></td>
                  <td colSpan="3">
                    <textarea
                      style={{
                        width: "93%",
                        margin: "5px 12px 5px 0",
                        fontSize: 15,
                      }}
                      name="behavior_q1_description"
                      value={behavior_q1_description}
                      placeholder="Description.."
                      id=""
                      cols="1"
                      rows="2"
                    ></textarea>
                  </td>
                </tr>
              )}
              <tr>
                <td className="text-align-center">2</td>
                <td className="text-left" style={{ maxWidth: 250 }}>
                  Has {name ? name : "***"} ever shown a loss of manners of
                  decorum? For example, a lacking response to social cues,
                  making crude or sexually explicit remarks, saying jokes or
                  voicing opinions that may be offensive to others.
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q2_status == "1" ? "button active" : "button"
                    }
                  >
                    Y
                  </button>
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q2_status == "N" ? "button active" : "button"
                    }
                  >
                    N
                  </button>
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q2_status == "DK" ? "button active" : "button"
                    }
                  >
                    DK
                  </button>
                </td>
                <td>
                  <input
                    type="number"
                    className="ecas-input-field"
                    placeholder="Score"
                    disabled={true}
                    value={behavior_q2_status == true ? 1 : 0}
                    style={{
                      width: "92%",
                      marginRight: 14,
                      marginBottom: 10,
                    }}
                  />
                </td>
              </tr>
              {behavior_q2_status == true && (
                <tr>
                  <td colSpan="2"></td>
                  <td colSpan="3">
                    <textarea
                      style={{
                        width: "93%",
                        margin: "5px 12px 5px 0",
                        fontSize: 15,
                      }}
                      name="behavior_q2_description"
                      value={behavior_q2_description}
                      placeholder="Description.."
                      id=""
                      cols="1"
                      rows="2"
                    ></textarea>
                  </td>
                </tr>
              )}
              <tr>
                <td className="text-align-center">3</td>
                <td className="text-left" style={{ maxWidth: 250 }}>
                  Does {name ? name : "***"} ever exhibit impulsive, rash or
                  careless actions? For example, a new onset of gambling, buying
                  or selling property without regard for consequences, giving
                  out personal information such as credit card numbers
                  inappropriately.
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q3_status == "1" ? "button active" : "button"
                    }
                  >
                    Y
                  </button>
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q3_status == "N" ? "button active" : "button"
                    }
                  >
                    N
                  </button>
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q3_status == "DK" ? "button active" : "button"
                    }
                  >
                    DK
                  </button>
                </td>
                <td>
                  <input
                    type="number"
                    className="ecas-input-field"
                    placeholder="Score"
                    disabled={true}
                    value={behavior_q3_status == true ? 1 : 0}
                    style={{
                      width: "92%",
                      marginRight: 14,
                      marginBottom: 10,
                    }}
                  />
                </td>
              </tr>
              {behavior_q3_status == true && (
                <tr>
                  <td colSpan="2"></td>
                  <td colSpan="3">
                    <textarea
                      style={{
                        width: "93%",
                        margin: "5px 12px 5px 0",
                        fontSize: 15,
                      }}
                      name="behavior_q3_description"
                      value={behavior_q3_description}
                      placeholder="Description.."
                      id=""
                      cols="1"
                      rows="2"
                    ></textarea>
                  </td>
                </tr>
              )}
              <tr>
                <td className="text-align-center">
                  <b>B</b>
                </td>
                <td className="text-left" colSpan="4">
                  <b>Apathy or inertia</b>
                </td>
              </tr>
              <tr>
                <td className="text-align-center">4</td>
                <td className="text-left" style={{ maxWidth: 250 }}>
                  Has {name ? name : "***"} shown a loss of interest, drive, or
                  motivation? Do you often have to prompt them to initiate or
                  continue routine activities?
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q4_status == "1" ? "button active" : "button"
                    }
                  >
                    Y
                  </button>
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q4_status == "N" ? "button active" : "button"
                    }
                  >
                    N
                  </button>
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q4_status == "DK" ? "button active" : "button"
                    }
                  >
                    DK
                  </button>
                </td>
                <td>
                  <input
                    type="number"
                    className="ecas-input-field"
                    placeholder="Score"
                    disabled={true}
                    value={behavior_q4_status == true ? 1 : 0}
                    style={{
                      width: "92%",
                      marginRight: 14,
                      marginBottom: 10,
                    }}
                  />
                </td>
              </tr>
              {behavior_q4_status == "1" && (
                <tr>
                  <td colSpan="2"></td>
                  <td colSpan="3">
                    <textarea
                      style={{
                        width: "93%",
                        margin: "5px 12px 5px 0",
                        fontSize: 15,
                      }}
                      name="behavior_q4_description"
                      value={behavior_q4_description}
                      placeholder="Description.."
                      cols="1"
                      rows="2"
                    ></textarea>
                  </td>
                </tr>
              )}
              <tr>
                <td className="text-align-center">
                  <b>C</b>
                </td>
                <td className="text-left" colSpan="4">
                  <b>Loss of sympathy or empathy</b>
                </td>
              </tr>
              <tr>
                <td className="text-align-center">5</td>
                <td className="text-left" style={{ maxWidth: 250 }}>
                  Do you think that {name ? name : "***"} has shown a diminished
                  response to people's feelings? Do they ever make hurtful
                  comments or show a lack of understanding of others' pain or
                  distress?
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q5_status == "1" ? "button active" : "button"
                    }
                  >
                    Y
                  </button>
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q5_status == "N" ? "button active" : "button"
                    }
                  >
                    N
                  </button>
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q5_status == "DK" ? "button active" : "button"
                    }
                  >
                    DK
                  </button>
                </td>
                <td>
                  <input
                    type="number"
                    className="ecas-input-field"
                    placeholder="Score"
                    disabled={true}
                    value={behavior_q5_status == true ? 1 : 0}
                    style={{
                      width: "92%",
                      marginRight: 14,
                      marginBottom: 10,
                    }}
                  />
                </td>
              </tr>
              {behavior_q5_status == "1" && (
                <tr>
                  <td colSpan="2"></td>
                  <td colSpan="3">
                    <textarea
                      style={{
                        width: "93%",
                        margin: "5px 12px 5px 0",
                        fontSize: 15,
                      }}
                      name="behavior_q5_description"
                      value={behavior_q5_description}
                      placeholder="Description.."
                      id=""
                      cols="1"
                      rows="2"
                    ></textarea>
                  </td>
                </tr>
              )}
              <tr>
                <td className="text-align-center">6</td>
                <td className="text-left" style={{ maxWidth: 250 }}>
                  Has {name ? name : "***"} shown a diminished social interest
                  or general closeness in social engagement? For example being
                  cold towards others or lacking eye contact when speaking with
                  others.
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q6_status == "1" ? "button active" : "button"
                    }
                  >
                    Y
                  </button>
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q6_status == "N" ? "button active" : "button"
                    }
                  >
                    N
                  </button>
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q6_status == "DK" ? "button active" : "button"
                    }
                  >
                    DK
                  </button>
                </td>
                <td>
                  <input
                    type="number"
                    className="ecas-input-field"
                    placeholder="Score"
                    disabled={true}
                    value={behavior_q6_status == true ? 1 : 0}
                    style={{
                      width: "92%",
                      marginRight: 14,
                      marginBottom: 10,
                    }}
                  />
                </td>
              </tr>
              {behavior_q6_status == "1" && (
                <tr>
                  <td colSpan="2"></td>
                  <td colSpan="3">
                    <textarea
                      style={{
                        width: "93%",
                        margin: "5px 12px 5px 0",
                        fontSize: 15,
                      }}
                      name="behavior_q6_description"
                      value={behavior_q6_description}
                      placeholder="Description.."
                      id=""
                      cols="1"
                      rows="2"
                    ></textarea>
                  </td>
                </tr>
              )}
              <tr>
                <td className="text-align-center">
                  <b>D</b>
                </td>
                <td className="text-left" colSpan="4">
                  <b>
                    Perseverative, stereotyped, compulsive or ritualistic
                    behavior
                  </b>
                </td>
              </tr>
              <tr>
                <td className="text-align-center">7</td>
                <td className="text-left" style={{ maxWidth: 250 }}>
                  Has {name ? name : "***"} exhibited any simple repetitive
                  movements such as tapping, clapping, scratching, picking skin,
                  or repeating words?
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q7_status == "1" ? "button active" : "button"
                    }
                  >
                    Y
                  </button>
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q7_status == "N" ? "button active" : "button"
                    }
                  >
                    N
                  </button>
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q7_status == "DK" ? "button active" : "button"
                    }
                  >
                    DK
                  </button>
                </td>
                <td>
                  <input
                    type="number"
                    className="ecas-input-field"
                    placeholder="Score"
                    disabled={true}
                    value={behavior_q7_status == true ? 1 : 0}
                    style={{
                      width: "92%",
                      marginRight: 14,
                      marginBottom: 10,
                    }}
                  />
                </td>
              </tr>
              {behavior_q7_status == "1" && (
                <tr>
                  <td colSpan="2"></td>
                  <td colSpan="3">
                    <textarea
                      style={{
                        width: "93%",
                        margin: "5px 12px 5px 0",
                        fontSize: 15,
                      }}
                      name="behavior_q7_description"
                      value={behavior_q7_description}
                      placeholder="Description.."
                      id=""
                      cols="1"
                      rows="2"
                    ></textarea>
                  </td>
                </tr>
              )}
              <tr>
                <td className="text-align-center">8</td>
                <td className="text-left" style={{ maxWidth: 250 }}>
                  Does {name ? name : "***"} engage in any complex, compulsive
                  or ritualistic behaviors? For example, counting, cleaning
                  rituals, collecting, or hoarding.
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q8_status == "1" ? "button active" : "button"
                    }
                  >
                    Y
                  </button>
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q8_status == "N" ? "button active" : "button"
                    }
                  >
                    N
                  </button>
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q8_status == "DK" ? "button active" : "button"
                    }
                  >
                    DK
                  </button>
                </td>
                <td>
                  <input
                    type="number"
                    className="ecas-input-field"
                    placeholder="Score"
                    disabled={true}
                    value={behavior_q8_status == true ? 1 : 0}
                    style={{
                      width: "92%",
                      marginRight: 14,
                      marginBottom: 10,
                    }}
                  />
                </td>
              </tr>
              {behavior_q8_status == "1" && (
                <tr>
                  <td colSpan="2"></td>
                  <td colSpan="3">
                    <textarea
                      style={{
                        width: "93%",
                        margin: "5px 12px 5px 0",
                        fontSize: 15,
                      }}
                      name="behavior_q8_description"
                      value={behavior_q8_description}
                      placeholder="Description.."
                      id=""
                      cols="1"
                      rows="2"
                    ></textarea>
                  </td>
                </tr>
              )}
              <tr>
                <td className="text-align-center">
                  <b>E</b>
                </td>
                <td className="text-left" colSpan="4">
                  <b>Hyperorality and altered food preferences</b>
                </td>
              </tr>
              <tr>
                <td className="text-align-center">9</td>
                <td className="text-left" style={{ maxWidth: 250 }}>
                  Has {name ? name : "***"} had any changes in their food
                  preferences or new cravings?
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q9_status == "1" ? "button active" : "button"
                    }
                  >
                    Y
                  </button>
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q9_status == "N" ? "button active" : "button"
                    }
                  >
                    N
                  </button>
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q9_status == "DK" ? "button active" : "button"
                    }
                  >
                    DK
                  </button>
                </td>
                <td>
                  <input
                    type="number"
                    className="ecas-input-field"
                    placeholder="Score"
                    disabled={true}
                    value={behavior_q9_status == true ? 1 : 0}
                    style={{
                      width: "92%",
                      marginRight: 14,
                      marginBottom: 10,
                    }}
                  />
                </td>
              </tr>
              {behavior_q9_status == "1" && (
                <tr>
                  <td colSpan="2"></td>
                  <td colSpan="3">
                    <textarea
                      style={{
                        width: "93%",
                        margin: "5px 12px 5px 0",
                        fontSize: 15,
                      }}
                      name="behavior_q9_description"
                      value={behavior_q9_description}
                      placeholder="Description.."
                      id=""
                      cols="1"
                      rows="2"
                    ></textarea>
                  </td>
                </tr>
              )}
              <tr>
                <td className="text-align-center">10</td>
                <td className="text-left" style={{ maxWidth: 250 }}>
                  Has {name ? name : "***"} shown any behavior such as binge
                  eating or consuming inedible objects?
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q10_status == "1" ? "button active" : "button"
                    }
                  >
                    Y
                  </button>
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q10_status == "N" ? "button active" : "button"
                    }
                  >
                    N
                  </button>
                </td>
                <td className="pl-0 text-align-center">
                  <button
                    className={
                      behavior_q10_status == "DK" ? "button active" : "button"
                    }
                  >
                    DK
                  </button>
                </td>
                <td>
                  <input
                    type="number"
                    className="ecas-input-field"
                    placeholder="Score"
                    disabled={true}
                    value={behavior_q10_status == true ? 1 : 0}
                    style={{
                      width: "92%",
                      marginRight: 14,
                      marginBottom: 10,
                    }}
                  />
                </td>
              </tr>
              {behavior_q10_status == "1" && (
                <tr>
                  <td colSpan="2"></td>
                  <td colSpan="3">
                    <textarea
                      style={{
                        width: "93%",
                        margin: "5px 12px 5px 0",
                        fontSize: 15,
                      }}
                      name="behavior_q10_description"
                      value={behavior_q10_description}
                      placeholder="Description.."
                      id=""
                      cols="1"
                      rows="2"
                    ></textarea>
                  </td>
                </tr>
              )}
              <tr className="light-grey">
                <td
                  className="text-left"
                  style={{ paddingLeft: 50 }}
                  colSpan="5"
                >
                  <b>SCORE</b>
                </td>
              </tr>
              <tr>
                <td className="text-right pr-3" colSpan="4">
                  TOTAL
                </td>
                <td className="text-align-center" colSpan="4">
                  <b>
                    {total_behavior_marks}
                    /10
                  </b>
                </td>
              </tr>
              <tr className="light-grey">
                <td
                  className="text-left"
                  style={{ paddingLeft: 50 }}
                  colSpan="5"
                >
                  <b>SYMPTOMS</b>
                </td>
              </tr>
              <tr>
                <td
                  className="text-left"
                  style={{ paddingLeft: 50 }}
                  colSpan="5"
                >
                  Please tick box if at least one of the symptoms was present in
                  each of the following categories.
                </td>
              </tr>
              <tr>
                <td
                  className="text-left"
                  style={{
                    paddingLeft: 20,
                    fontSize: 16,
                  }}
                  colSpan="5"
                >
                  <b>A. Behavioural disinhibition</b>
                  <input
                    className="position-relative"
                    type="checkbox"
                    name="behaviour_symptom_status"
                    checked={behaviour_symptom_status == "1" ? true : false}
                    style={{
                      width: 20,
                      left: 12,
                      top: 3,
                    }}
                  />
                </td>
              </tr>
              <tr>
                <td
                  className="text-left"
                  style={{
                    paddingLeft: 20,
                    fontSize: 16,
                  }}
                  colSpan="5"
                >
                  <b>B. Apathy or inertia</b>
                  <input
                    className="position-relative"
                    type="checkbox"
                    name="apathy_symptom_status"
                    checked={apathy_symptom_status == "1" ? true : false}
                    style={{
                      width: 20,
                      left: 12,
                      top: 3,
                    }}
                  />
                </td>
              </tr>
              <tr>
                <td
                  className="text-left"
                  style={{
                    paddingLeft: 20,
                    fontSize: 16,
                  }}
                  colSpan="5"
                >
                  <b>C. Loss of sympathy or empathy</b>
                  <input
                    className="position-relative"
                    type="checkbox"
                    name="loss_sympathy_symptom_status"
                    checked={loss_sympathy_symptom_status == "1" ? true : false}
                    style={{
                      width: 20,
                      left: 12,
                      top: 3,
                    }}
                  />
                </td>
              </tr>
              <tr>
                <td
                  className="text-left"
                  style={{
                    paddingLeft: 20,
                    fontSize: 16,
                  }}
                  colSpan="5"
                >
                  <b>
                    D. Perseverative, stereotyped, compulsive or ritualistic
                    behaviour
                  </b>
                  <input
                    className="position-relative"
                    type="checkbox"
                    name="perseverative_symptom_status"
                    checked={perseverative_symptom_status == "1" ? true : false}
                    style={{
                      width: 20,
                      left: 12,
                      top: 3,
                    }}
                  />
                </td>
              </tr>
              <tr>
                <td
                  className="text-left"
                  style={{
                    paddingLeft: 20,
                    fontSize: 16,
                  }}
                  colSpan="5"
                >
                  <b>E. Hyperorality and altered food preferences</b>
                  <input
                    className="position-relative"
                    type="checkbox"
                    name="hyperorality_symptom_status"
                    checked={hyperorality_symptom_status == "1" ? true : false}
                    style={{
                      width: 20,
                      left: 12,
                      top: 3,
                    }}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
